import FormItem from './QueryForm'
import TableList from './TableList'

export default {
  install(app) {
    app.use(FormItem).use(TableList)
  },
}
